<cc-channels-details button="CHANNELS.REGISTER.NEXT" [invited]="false"></cc-channels-details>
